/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description discretize
 */

// rounds num to a multiple of base
const discretize = (num, base, round) => {
  let mult = num / base
  if (round > 0) {
    mult = Math.ceil(mult)
  } else if (round < 0) {
    mult = Math.floor(mult)
  } else {
    mult = Math.round(mult)
  }
  return mult * base
}

export default discretize
